import React from "react";

import imageCompression from "browser-image-compression";

import Card from "react-bootstrap/Card";

export default class ImageCompressor extends React.Component {
  constructor() {
    super();
    this.state = {
      compressedLink:
        "http://navparivartan.in/wp-content/uploads/2018/11/placeholder.png",
      originalImage: "",
      originalLink: "",
      clicked: false,
      uploadImage: false,
    };
  }

  handle = (e) => {
    const imageFile = e.target.files[0];

    this.setState({
      originalLink: URL.createObjectURL(imageFile),
      originalImage: imageFile,
      outputFileName: imageFile.name,
      uploadImage: true,
      height: imageFile.height,
      width: imageFile.width,
    });
  };

  changeValue = (e) => {
    // if (3000 != this.state.height && 3000 != this.state.width) {
    //   alert("please upload an image that is 3000 x 3000 pixels");
    //   return 0;
    // }
    this.setState({ [e.target.name]: e.target.value });
  };
  componentDidMount() {
    // if (!this.state.originalImage) {
    //   alert("no image");
    // }
  }
  click = (e) => {
    e.preventDefault();

    const options = {
      dim: 3000,
      maxSizeMB: 1,
      maxWidthOrHeight: 300,
      useWebWorker: true,
    };
    if (options.dim != this.state.height && options.dim != this.state.width) {
      alert("please upload an image that is 3000 x 3000 pixels");
      return 0;
    }
    // if (options.maxSizeMB >= this.state.originalImage.size / 1024) {
    //   alert("Image is too small, can't be Compressed!");
    //   return 0;
    // }

    let output;
    imageCompression(this.state.originalImage, options).then((x) => {
      output = x;

      const downloadLink = URL.createObjectURL(output);
      this.setState({
        compressedLink: downloadLink,
      });
    });

    this.setState({ clicked: true });
    return 1;
  };

  render() {
    return (
      <div className="m-5">
        <div className="text-light text-center">
          <h1>album cover</h1>
          <h3>please upload a file with dimensions 3000 x 3000</h3>
        </div>

        <div className="row mt-5">
          <div
            className="col-xl-4 col-lg-4 col-md-12 col-sm-12"
            style={{ width: 200 }}
          >
            {this.state.uploadImage ? (
              <Card.Img
                className="ht"
                variant="top"
                src={this.state.originalLink}
              ></Card.Img>
            ) : (
              <Card.Img
                className="ht"
                variant="top"
                src="http://navparivartan.in/wp-content/uploads/2018/11/placeholder.png"
              ></Card.Img>
            )}
            <div className="d-flex justify-content-center">
              <input
                type="file"
                accept="image/*"
                className="mt-2 btn btn-dark w-75"
                onChange={(e) => this.handle(e)}
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 mb-5 mt-5 col-sm-12 d-flex justify-content-center align-items-baseline">
            <br />
            {this.state.outputFileName ? (
              <button
                type="button"
                className=" btn btn-dark"
                onClick={(e) => this.click(e)}
              >
                save
              </button>
            ) : (
              <></>
            )}
          </div>

          {/* <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 mt-3">
            <Card.Img variant="top" src={this.state.compressedLink}></Card.Img>
            {this.state.clicked ? (
              <div className="d-flex justify-content-center">
                <a
                  href={this.state.compressedLink}
                  download={this.state.outputFileName}
                  className="mt-2 btn btn-dark w-75"
                >
                  Download
                </a>
              </div>
            ) : (
              <></>
            )}
          </div> */}
        </div>
      </div>
    );
  }
}
